const isNullOrUndefined = function(value) {
    return value === null || value === undefined;
};

const minPasswordLength = 8;
const allowedPasswordSpecialCharacters = '*!@#$&=_+';

const isEmpty = function(value) {
    // We may want to handle booleans. Passing NaN will return false.
    if (isNullOrUndefined(value)) {
        return true;
    }
    if (typeof value === 'boolean') {
        return false;
    }
    if (typeof value === 'object') {
        return Object.keys(value).length === 0;
    } else {
        return !value.toString().trim();
    }
};

const isValidPasswordLength = function (password) {
    if (isNullOrUndefined(password)) {
        return false;
    }
    return password.length >= minPasswordLength;
};

const passwordHasUppercaseLetter = function (password) {
    if (isNullOrUndefined(password)) {
        return false;
    }
    return password.search(/[A-Z]/) !== -1;
};

const passwordHasLowercaseLetter = function (password) {
    if (isNullOrUndefined(password)) {
        return false;
    }
    return password.search(/[a-z]/) !== -1;
};

const passwordHasDigit = function (password) {
    if (isNullOrUndefined(password)) {
        return false;
    }
    return password.search(/\d/) !== -1;
};

const isValidPasswordPattern = function (password) {
    if (isNullOrUndefined(password)) {
        return false;
    }
    const pattern = `^(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])[\\w${allowedPasswordSpecialCharacters}]{${minPasswordLength},}$`;
    const regExp = new RegExp(pattern);
    return regExp.test(password);
};

const isValidPhoneNumber = function (phoneNumber) {
    if (isNullOrUndefined(phoneNumber)) {
        return false;
    }
    const phonePattern = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    return (phoneNumber.length > 0 && phonePattern.test(phoneNumber));
};

const stateBelongsToList = (list, state) => {
    const acronyms = list.map( individualState => individualState.acronym);
    return acronyms.includes(state);
};

export {
    isNullOrUndefined,
    isEmpty,
    isValidPhoneNumber,
    minPasswordLength,
    isValidPasswordLength,
    passwordHasUppercaseLetter,
    passwordHasLowercaseLetter,
    passwordHasDigit,
    isValidPasswordPattern,
    allowedPasswordSpecialCharacters,
    stateBelongsToList,
};



// WEBPACK FOOTER //
// ./src/js/utilities/validation.js